
import React from 'react';
import { Item } from '../interfaces';
import ItemRow from './ItemRow';

interface CartTableProps {
  items: Item[];
  title: string;
  onUpdate: (item: Item, newName: string) => Promise<boolean>;
  onDelete: (item: Item) => void;
  onRefresh?: (item: Item) => void;
  columns: string[];
  onSaveSettings: (item: Item, settings: { is_tracked_periodically: boolean; selected_websites: string[]; use_ai_to_find_product: boolean }) => void;
  isGeminiProcessing: boolean;
  userId: string | null;
}

const CartTable: React.FC<CartTableProps> = ({ items, onUpdate, onDelete, onRefresh, columns, onSaveSettings, isGeminiProcessing, userId }) => {
  return (
    <table className="table align-middle mb-0">
      <thead>
        <tr>
          {columns.map((col, idx) => (
            <th 
              key={idx} 
              className={`${col === 'Item Name' ? 'ps-4' : ''} ${col === 'Actions' ? 'text-end pe-4' : ''}`}
            >
              {col}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {items.length === 0 ? (
          <tr>
            <td colSpan={columns.length} className="text-center py-5 text-muted">
              No items in this list yet.
            </td>
          </tr>
        ) : (
          items.map((item) => (
            <ItemRow 
              key={item.id} 
              item={item} 
              onUpdate={onUpdate}
              onDelete={onDelete}
              onRefresh={onRefresh}
              columns={columns}
              onSaveSettings={onSaveSettings} 
              isGeminiProcessing={isGeminiProcessing} 
              userId={userId} 
            />
          ))
        )}
      </tbody>
    </table>
  );
};

export default CartTable;
